var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M77.1 50.4L35.7 75.2V25.6z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1wbGF5IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSI+CiAgPGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiIGZpbGw9IndoaXRlIj48L2NpcmNsZT4KICA8cGF0aCBmaWxsPSJncmV5IiBkPSJNNzcuMSA1MC40TDM1LjcgNzUuMlYyNS42eiI+PC9wYXRoPgo8L3N2Zz4K";
export { SvgIconPlay as ReactComponent };